








import {Component, Prop, Vue} from "vue-property-decorator";
import LensIcon from  '../../../../assets/svg/web-conferences/lens.svg';
import TimesIcon from '../../../../assets/svg/web-conferences/times.svg'

@Component({
  name: "SearchBar",
  components: {LensIcon, TimesIcon}
})
export default class SearchBar extends Vue {
  @Prop() value: string;

  onClear() {
    // this.value = '';
    this.$emit('input', "");
  }
}
